import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Grid, Paper, Button } from '@material-ui/core';
import { CircularProgress, Typography, Divider } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import TextField from 'components/Form/TextField';
import TagList from './TagList/TagList';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import styles from '../App.css';
import componentStyles from './LoginPage.css';
import Translation from '../../components/Translation/Translation';

@inject('customerCaseStore')
@observer
export default class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.updateProperty = this.updateProperty.bind(this);
  }

  componentDidMount() {}

  updateProperty(key, value) {
    this.props.formDataStore.customerCase.customer[key] = value;
  }

  changeValue(id, targetArray, key, event) {
    console.log(event.target.value);
    this.props.formDataStore.assignValueToProperty(
      id,
      targetArray,
      key,
      event.target.value
    );
  }

  renderData() {
    return (
      <Grid item xs={12}>
        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>username</Translation>}
            onChange={event => {
              this.props.customerCaseStore.changeUsername(event);
            }}
            style={componentStyles.textField}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>password</Translation>}
            type="password"
            onChange={event => {
              this.props.customerCaseStore.changePassword(event);
            }}
            style={componentStyles.textField}
          />
        </Grid>

        <Button variant="raised" color="primary" onClick={() => this.props.customerCaseStore.userLogin()}>
          <Translation>login</Translation>
        </Button>
      </Grid>
    );
  }

  render() {
    if (this.props.customerCaseStore.currentUser != null) {
      return <Redirect to="/cases/"/>
    }

    return (
      <Grid item xs={12}>
        <Paper style={styles.paper}>{this.renderData()}</Paper>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/LoginPage/LoginPage.jsx